var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM10.6 12C10.6 12.7732 11.2268 13.4 12 13.4C12.7732 13.4 13.4 12.7732 13.4 12C13.4 11.2268 12.7732 10.6 12 10.6C11.2268 10.6 10.6 11.2268 10.6 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V11",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12.5 12.5",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C9.38071 2 10.5 3.11929 10.5 4.5C10.5 5.88071 9.38071 7 8 7C6.61929 7 5.5 5.88071 5.5 4.5C5.5 3.11929 6.61929 2 8 2Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 8C9.27465 8.00003 10.5046 8.37062 11.5032 9.04102C10.0829 9.27785 9.00024 10.5125 9.00024 12C9.00024 12.351 9.06329 12.6869 9.17407 13H4.17407C3.11744 13 2.23083 12.234 2.57641 11.3643C2.858 10.6559 3.32163 10.005 3.94165 9.46484C5.01809 8.52722 6.47796 8 8.00024 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarClock);
export default __webpack_public_path__ + "static/media/avatar-clock.7bff28ac6b4ded98402bcdd1f413ef08.svg";
export { ForwardRef as ReactComponent };